import CSS from 'csstype';
import React from 'react';

import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { borderRadius, Col, Cols, spacing, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

interface IIconTextProps {
  color?: string;
  iconColor?: string; // only use if the icon color differs from the text color
  enableBorder?: boolean;
  bold?: boolean;
  icon: string; // refer to iconV2
  text: string;
  onClick?: () => void;
  style?: CSS.Properties;
  gap?: string;
  // size
  mini?: boolean;
  extraSmall?: boolean;
  small?: boolean;
  baseSize?: boolean;
  large?: boolean;
  extraLarge?: boolean;
  noPadding?: boolean;
}

export const IconText = (props: IIconTextProps) => {
  const {
    color = publicaColors.black,
    iconColor,
    enableBorder,
    bold,
    icon,
    text,
    onClick,
    style,
    gap,
    mini,
    extraSmall,
    small,
    baseSize,
    large,
    extraLarge,
    noPadding,
  } = props;

  return (
    <div onClick={() => onClick && onClick()}>
      <Cols
        gap={gap || spacing.small}
        style={{
          alignItems: 'center',
          width: 'fit-content',
          border: `${enableBorder ? `0.5px solid ${publicaColors.lightGray}` : 'none'}`,
          borderRadius: borderRadius.base,
          padding: noPadding ? '0px' : '4px 8px',
          ...style,
        }}
      >
        <Col displayFlex>
          {
            <IconV2
              name={icon}
              color={iconColor || color}
              small={mini || extraSmall || small}
              large={large || extraLarge}
            />
          }
        </Col>
        <Col>
          <Text
            bold={bold}
            color={color}
            mini={mini}
            extraSmall={extraSmall}
            small={small}
            baseSize={baseSize}
            large={large}
            extraLarge={extraLarge}
          >
            {text}
          </Text>
        </Col>
      </Cols>
    </div>
  );
};
